import { createContext, ReactElement, ReactNode, useContext } from 'react'

import { Account, AccountNature } from '@modules-deprecated/app/accounts/types'

import { useCreateAccountFromTemplateModal } from '../hooks/useCreateAccountFromTemplateModal'

type ContextState = ReturnType<typeof useCreateAccountFromTemplateModal>

const CreateAccountFromTemplateFormContext = createContext<ContextState | undefined>(undefined)

interface CreateAccountFromTemplateFormContextProviderProps {
  children: ReactNode
  natures?: AccountNature[]
  onClose?: () => void
  onSave?: (account: Account) => void
}

export const CreateAccountFromTemplateFormContextProvider = ({
  children,
  natures,
  onClose,
  onSave,
}: CreateAccountFromTemplateFormContextProviderProps): ReactElement => {
  const contextValue = useCreateAccountFromTemplateModal({ natures, onClose, onSave })

  return (
    <CreateAccountFromTemplateFormContext.Provider value={contextValue}>
      {children}
    </CreateAccountFromTemplateFormContext.Provider>
  )
}

export const useCreateAccountFromTemplateForm = (): ContextState => {
  const context = useContext(CreateAccountFromTemplateFormContext)

  if (!context) {
    throw new Error('CreateAccountFromTemplateFormContextProvider is missing in the module!')
  }

  return context
}
